import { useId, useRef, useState } from 'react'

import { useCountDown } from 'ahooks'

import { sendSmsCodeApi } from '@eastcoal/api/nexus/sms/sendSmsCode'
import { sendSmsCodeWithCaptchaApi } from '@eastcoal/api/nexus/sms/sendSmsCodeWithCaptcha'

import { initCaptcha } from '../../lib/captcha'
import { CaptchaInstance } from '../../lib/captcha/interface'
import { ThrottleButton } from '../Button/ThrottleButton'

import { SmsButtonProps } from './interface'

export const SmsButton = ({
  /* -------------------------------------------------------------------------- */
  /*                          SendSmsCodeApi Parameter                          */
  /* -------------------------------------------------------------------------- */
  api,
  captchaEnabled = false,
  captchaSceneId = '1ksgfgj0',
  requirePhone = true,
  phone,
  digit,
  expire,
  comment,
  templateCode,
  templateParam,
  /* -------------------------------------------------------------------------- */
  /*                                Button Props                                */
  /* -------------------------------------------------------------------------- */
  type,
  disabled,

  /* -------------------------------------------------------------------------- */
  /*                               SmsButton Props                              */
  /* -------------------------------------------------------------------------- */
  onSuccess
}: SmsButtonProps) => {
  const btnId = useId()
  const captchaContainerId = useId()
  const captchaInstanceRef = useRef<CaptchaInstance>(undefined)
  const [leftTime, setLeftTime] = useState(0)
  const [countdown] = useCountDown({
    leftTime,
    onEnd: () => setLeftTime(0)
  })
  const seconds = Math.floor(countdown / 1000)

  const handleClick = async () => {
    if (captchaEnabled) {
      const captchaInstance = await initCaptcha({
        mode: 'popup',
        SceneId: captchaSceneId,
        button: `#${btnId}`,
        element: `#${captchaContainerId}`,
        success: doRequest,
        getInstance(instance) {
          captchaInstanceRef.current = instance
        }
      })
      // captchaInstance.show()
      captchaInstance.startTracelessVerification()
      // 如果前端人机验证功能异常也没关系，后台会返回异常
    } else {
      doRequest()
    }
  }

  const doRequest = async (captchaVerifyParam?: string) => {
    try {
      // 1 分钟
      setLeftTime(60_000)
      const requestApi =
        api ?? (captchaEnabled ? sendSmsCodeWithCaptchaApi : sendSmsCodeApi)
      const res = await requestApi(
        {
          phone,
          digit,
          expire,
          comment,
          templateCode,
          templateParam,
          captchaSceneId,
          captchaVerifyParam
        },
        {
          tipDuration: 5
        }
      )
      onSuccess?.(res)
    } catch {
      // 发送失败的话允许用户立刻重新获取
      setLeftTime(0)
    }
  }

  return (
    <>
      <ThrottleButton
        disabled={disabled || !!seconds || (requirePhone && !phone)}
        id={btnId}
        type={type}
        onClick={handleClick}
      >
        {seconds ? `${seconds}秒后重新获取` : '获取短信验证码'}
      </ThrottleButton>
      <div id={captchaContainerId} />
    </>
  )
}
